export const aboutData = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDesc: false,
    topLine: 'About Me',
    headline: 'This is the Headline about me',
    description: 'I\'m an experienced software engineer with 5+ years in defence and R&D sectors, specialising in full-stack development, DevOps, Systems Administration, and complex system integrations. I\'m super interested in all kinds of technologies and am very eager to gain more experience in full stack development, web/app development, interface design, cloud services, machine learning and expanding my software engineering skills.\n\n I enjoy working on projects that I feel passionate about and learning new frameworks or programming languages. I\'m always motivated to further my career and take on challenges that allow me to grow!',
    buttonLabel: 'Get started',
    imgStart: false,
    isVid: false,
    img: null,
    alt: 'me',
    dark: true,
    primary: true,
    darkText: true
}
